import { ArrowRight } from "lucide-react";
import { Chapter, Reveal } from "@/components/Reveal";
import { GhostCTA } from "@/components/CTA";

const SERVICES = [
  { t: "SOCIAL MEDIA MANAGEMENT", d: "Gestione operativa della presenza social delle aziende." },
  { t: "CONTENT CREATION", d: "Contenuti, reel, creatività e storytelling." },
  { t: "WEB EXPERIENCE", d: "Siti web moderni, dinamici, responsive e orientati all'esperienza dell'utente." },
  { t: "AI & AUTOMATION", d: "Applicazioni e automazioni digitali basate sull'intelligenza artificiale." },
];

const DeltaSection = () => (
  <section id="delta" data-testid="delta-section" className="bg-ink py-28 text-white lg:py-40">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <Chapter index="09" label="Estensione operativa" dark />
      <Reveal>
        <p className="max-w-xl font-mono text-[11px] uppercase leading-relaxed tracking-[0.25em] text-white/40">
          La strategia senza esecuzione rimane soltanto una buona idea.
        </p>
        <h2 className="mt-6 font-display text-4xl font-extrabold tracking-tighter sm:text-5xl lg:text-6xl">
          <span className="text-accent">Δ</span> DELTA DIGITAL AGENCY
        </h2>
        <p className="mt-4 font-display text-xl font-bold tracking-tight text-white/75">
          Il braccio operativo digitale.
        </p>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-white/55">
          Quando la strategia richiede anche execution, un team dedicato può trasformarla in operatività.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => (
          <Reveal key={s.t} delay={i * 0.07}>
            <article
              data-testid={`delta-service-${i + 1}`}
              className="h-full border border-white/10 p-7 transition-colors duration-500 hover:border-accent"
            >
              <span className="font-mono text-[10px] tracking-[0.3em] text-accent">0{i + 1}</span>
              <h3 className="mt-5 font-display text-base font-bold tracking-tight">{s.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/50">{s.d}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-16">
        <div className="flex flex-wrap items-center gap-6" data-testid="delta-before-after">
          <span className="border border-white/15 px-6 py-4 font-mono text-[11px] uppercase tracking-[0.3em] text-white/45">
            Before
          </span>
          <ArrowRight className="h-4 w-4 text-white/25" aria-hidden="true" />
          <span className="font-display text-6xl font-extrabold leading-none text-accent">Δ</span>
          <ArrowRight className="h-4 w-4 text-white/25" aria-hidden="true" />
          <span className="border border-accent px-6 py-4 font-mono text-[11px] uppercase tracking-[0.3em] text-white">
            After
          </span>
        </div>
      </Reveal>

      <Reveal delay={0.2} className="mt-14">
        <GhostCTA to="/delta" dark testid="delta-cta">
          Scopri Delta Digital Agency
        </GhostCTA>
      </Reveal>
    </div>
  </section>
);

export default DeltaSection;
